import { useContext, useEffect } from "react";
import {
  ViewTitleSetterContext,
  ViewTitleValueContext,
} from "../contexts/view_title/context";

/**
 * Registers `title` as the active view's title (rendered by TopHeader) and
 * clears it on unmount. Subscribes only to the stable setter context, so the
 * caller (a view container) is never re-rendered by title changes.
 */
export const useViewTitle = (title: string | null): void => {
  const setViewTitle = useContext(ViewTitleSetterContext);
  useEffect(() => {
    setViewTitle(title ?? null);
    return () => setViewTitle(null);
  }, [title, setViewTitle]);
};

/** Reads the active view's title. Intended for TopHeader. */
export const useViewTitleValue = (): string | null =>
  useContext(ViewTitleValueContext);
